//import { Document } from './document/document'
// TODO document2
import { Document } from './document2/document'
import { ApplicationState } from './applicationState/applicationState';
import { UserConfig } from './userConfig/userConfig';
import { MessageCenter } from './messageCenter/messageCenter';
import { FontManager } from './fontManager/fontManager';
import { ShortcutManager } from './shortcutManager/shortcutManager';
import { ClipboardManager } from './clipboardManager/clipboardManager';
import { DataContainer } from './dataContainer/dataContainer';

import * as def from '@/definitions'

export class Root 
{
    // ドキュメント
    public document : Document = new Document();

    // アプリケーション状態
    public applicationState : ApplicationState = new ApplicationState();

    // ユーザー設定
    public userConfig : UserConfig = new UserConfig();

    // フォント管理
    public fontManager : FontManager = new FontManager();

    // ショートカット管理
    public shortcutManager : ShortcutManager = new ShortcutManager();

    // クリップボード管理
    public clipboardManager : ClipboardManager = new ClipboardManager();

    // メッセージセンター
    public messageCenter : MessageCenter = new MessageCenter();

    // 汎用データクラス
    public dataContainer : DataContainer = new DataContainer();

    // setDocument(pageList){
    //     this.document.pageList[0] = pageList
    // }
}


